import Papa from 'papaparse'
import type { Row } from '../types'

export function parseCsv(text: string): Row[] {
  const result = Papa.parse<Row>(text.replace(/^\uFEFF/, ''), { header: true, skipEmptyLines: true })
  if (result.errors.length) throw new Error(`CSV inválido: ${result.errors[0].message}`)
  return result.data.map((row) => Object.fromEntries(Object.entries(row).map(([key, value]) => [key, String(value ?? '')])))
}

export function toCsv(headers: string[], rows: Row[]): string {
  return Papa.unparse(rows.map((row) => Object.fromEntries(headers.map((header) => [header, row[header] ?? '']))), {
    columns: headers,
    newline: '\n',
  })
}

export function downloadText(fileName: string, text: string, type = 'text/csv;charset=utf-8'): void {
  const blob = new Blob(['\uFEFF', text], { type })
  downloadBlob(fileName, blob)
}

export function downloadBlob(fileName: string, blob: Blob): void {
  const url = URL.createObjectURL(blob)
  const anchor = document.createElement('a')
  anchor.href = url
  anchor.download = fileName
  anchor.click()
  setTimeout(() => URL.revokeObjectURL(url), 1000)
}

export function copyText(text: string): Promise<void> {
  return navigator.clipboard.writeText(text)
}

export function parseList(value: string): string[] {
  const text = String(value ?? '').trim()
  if (!text) return []
  try {
    const parsed = JSON.parse(text)
    if (Array.isArray(parsed)) return parsed.map(String).filter(Boolean)
  } catch {
    // Continue with legacy delimiters.
  }
  return text.split(/\||;|\n/).map((item) => item.trim()).filter(Boolean)
}

export function encodeList(values: string[], format: 'json' | 'pipe' | 'semicolon' = 'json'): string {
  const clean = values.map((value) => value.trim()).filter(Boolean)
  if (format === 'pipe') return clean.join('|')
  if (format === 'semicolon') return clean.join('; ')
  return JSON.stringify(clean)
}

export function parseMap(value: string): Record<string, string> {
  try {
    const parsed = JSON.parse(value || '{}')
    return parsed && typeof parsed === 'object' && !Array.isArray(parsed)
      ? Object.fromEntries(Object.entries(parsed).map(([key, item]) => [key, String(item)]))
      : {}
  } catch {
    return {}
  }
}

export function normalizeText(value: string): string {
  return value.normalize('NFD').replace(/[\u0300-\u036f]/g, '').toLowerCase().replace(/[^a-z0-9]+/g, ' ').trim()
}
